/* PHOTOPRI Price List v2 — paper / framing comparator
 * Data sources (no hard-coded prices):
 *   window.PLV2_PAPER       : paper products [{handle,title,url,category,sizes{size:{p:cents,id}}}]
 *   window.PLV2_FRAMING_URL : asset_url of rf-custom-variants.json
 * Exception-safe: null guards everywhere, errors logged not swallowed silently.
 * Price cells link to product pages (?variant=id). Yen normalized via *100 cents to match cart.
 */
(function () {
  'use strict';

  // handle -> Japanese label (per current theme product titles)
  var FRAMING_LABELS = {
    'framing-p001': '木製額装',
    'framing-p002': 'アルミ額装',
    'canvas': 'キャンバス木枠張り',
    'wood-panel': '木製パネル加工',
    'styrene-panel': 'スチレンパネル加工',
    'bookmat-mount': 'ブックマット加工',
    'caption-panel': 'キャプションパネル'
  };
  // size-based handles only (custom-size-option is a W×H matrix, excluded — never matches paper sizes)
  var FRAMING_HANDLE_ORDER = ['framing-p001', 'framing-p002', 'canvas', 'wood-panel', 'styrene-panel', 'bookmat-mount', 'caption-panel'];

  var NO_OPT = '__none__'; // sentinel for missing option2/option3

  // cross-section registry of rendered tables, so the calc tool can highlight a recommended size
  var SIZE_LISTENERS = []; // each: function(size){}
  var pendingHighlightSize = null;

  // 論理サイズ順（A系→B系→写真→F/額装→正方/大判）。未知サイズは末尾に出現順で温存。
  var SIZE_NAME_ORDER = [
    'A5', 'A4', 'A3', 'A3ノビ', 'A2', 'A2ノビ', 'A1', 'A1ノビ', 'A0', 'A0ノビ',
    'B5', 'B4', 'B3', 'B2', 'B1', 'B1ノビ', 'B0', 'B0ノビ',
    'L', 'ハガキ', '2L', '六切', '四切', 'ワイド四切', '半切', '全紙', '大全紙', '全倍',
    'SM', 'F4', 'F6', 'F8', 'F10', 'F15', 'F20',
    '200×200', '300×300', '400×400', '500×500', '600×600', '800×800',
    '1000×1000', '1000×1500', '1000×2000', '1000×3000'
  ];

  // サイズ表記の正規化: 全角カッコ→半角 / 'x'→'×'（データ表記ゆれを吸収しキーを統一）
  function normSize(s) {
    return String(s)
      .replace(/（/g, '(').replace(/）/g, ')')
      .replace(/(\d)[xX](\d)/g, '$1×$2');
  }

  // ソート用ランク: ラベルの「サイズ名」(カッコ前)を SIZE_NAME_ORDER で引く。未知は大きい値。
  function sizeRank(label) {
    var name = normSize(label).split('(')[0];
    var idx = SIZE_NAME_ORDER.indexOf(name);
    return idx === -1 ? 9999 : idx;
  }

  // サイズ配列を論理順に整列（同ランク・未知は元の出現順を温存＝安定ソート）
  function sortSizes(arr) {
    return arr.slice()
      .map(function (s, i) { return { s: s, i: i, r: sizeRank(s) }; })
      .sort(function (a, b) { return (a.r - b.r) || (a.i - b.i); })
      .map(function (o) { return o.s; });
  }

  function yen(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '-';
    return '¥' + Math.round(n / 100).toLocaleString('ja-JP');
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  // price link cell: <td><a href=...>¥x</a></td> ; '-' stays plain text
  function priceCell(cents, href, cls) {
    var td = el('td', cls || null);
    if (cents == null || href == null) {
      td.textContent = '-';
      return td;
    }
    var a = el('a', 'plv2-price-link', yen(cents));
    a.href = href;
    td.appendChild(a);
    return td;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // GA4 / GTM 共通トラッキング（解像度計算ツール等と同流儀: gtag + dataLayer 両系・未定義は no-op）
  function trackPL(eventName, params) {
    try {
      var payload = Object.assign({ tool: 'pricelist' }, params || {});
      if (typeof window.gtag === 'function') window.gtag('event', eventName, payload);
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: eventName }, payload));
    } catch (e) { /* swallow */ }
  }
  window.trackPricelist = trackPL; // 定形外サイズ計算ツール(テンプレ inline)からも利用

  // 価格セル(<a.plv2-price-link>)クリックを section root に委譲して計測（商品ページ送客=コンバージョン信号）
  function wirePriceClicks(rootEl, section) {
    if (!rootEl) return;
    rootEl.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a.plv2-price-link') : null;
      if (!a || !rootEl.contains(a)) return;
      trackPL('pricelist_price_click', { section: section, href: a.getAttribute('href') });
    });
  }

  ready(function () {
    var paper = Array.isArray(window.PLV2_PAPER) ? window.PLV2_PAPER : [];
    if (!paper.length) {
      console.error('[PLV2] window.PLV2_PAPER is empty or missing');
    }
    // normalize paper: ensure category/url fallback + サイズキーを正規化（全角カッコ等の表記ゆれを統一・マージ）
    paper.forEach(function (p) {
      if (!p.category) p.category = 'その他';
      if (!p.url) p.url = '';
      var src = p.sizes || {};
      var norm = {};
      Object.keys(src).forEach(function (k) {
        var nk = normSize(k);
        if (!(nk in norm)) norm[nk] = src[k]; // 同一商品内の重複は最初を優先（通常は発生しない）
      });
      p.sizes = norm;
    });

    // calc tool -> table sync (CustomEvent, minimal global pollution)
    document.addEventListener('plv2:size', function (ev) {
      var size = ev && ev.detail && ev.detail.size;
      if (!size) return;
      pendingHighlightSize = size;
      SIZE_LISTENERS.forEach(function (fn) {
        try { fn(size); } catch (e) { console.error('[PLV2] size listener error', e); }
      });
      // smooth scroll to section A so the user sees the highlighted row
      var secA = document.getElementById('plv2-sec-a');
      if (secA && secA.scrollIntoView) {
        secA.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    var framingUrl = window.PLV2_FRAMING_URL;
    if (!framingUrl) {
      console.error('[PLV2] window.PLV2_FRAMING_URL missing — framing sections will be empty');
      buildAll(paper, {}, {});
      return;
    }

    fetch(framingUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('framing fetch HTTP ' + r.status);
        return r.json();
      })
      .then(function (raw) {
        var framing = shapeFraming(raw);
        var customFraming = shapeCustomFraming(raw);
        buildAll(paper, framing, customFraming);
      })
      .catch(function (err) {
        console.error('[PLV2] framing load failed:', err);
        buildAll(paper, {}, {}); // still render paper section A
      });
  });

  // raw[] -> { handle: { opt2: { opt3: { size: { c: cents, id: variantId } } } } }
  function shapeFraming(raw) {
    var out = {};
    if (!Array.isArray(raw)) {
      console.error('[PLV2] framing json is not an array');
      return out;
    }
    raw.forEach(function (v) {
      try {
        var h = v.product_handle;
        if (!h || FRAMING_HANDLE_ORDER.indexOf(h) === -1) return; // skip custom-size-option etc.
        var o2 = (v.option2 != null && v.option2 !== '') ? v.option2 : NO_OPT;
        var o3 = (v.option3 != null && v.option3 !== '') ? v.option3 : NO_OPT;
        var size = v.option1;
        if (!size) return;
        size = normSize(size); // データ揺れ吸収（全角カッコ・'x'→'×'）し用紙サイズ表記に統一
        var price = Number(v.price);
        // price stored as yen integer in this asset (e.g. "7750"); convert to cents for unified yen()
        var cents = isFinite(price) ? price * 100 : NaN;
        out[h] = out[h] || {};
        out[h][o2] = out[h][o2] || {};
        out[h][o2][o3] = out[h][o2][o3] || {};
        out[h][o2][o3][size] = { c: cents, id: v.id };
      } catch (e) {
        console.error('[PLV2] bad framing row', v, e);
      }
    });
    return out;
  }

  /* ============ 定形外（カスタム）サイズの額装/加工 ============
   * custom-size-option は (option1=額装種別, option2=短辺レンジ上限, option3=長辺レンジ上限) の価格マトリクス。
   * カラー次元なし・価格はレンジ上限で決まる。短辺=min(W,H) / 長辺=max(W,H) を収める最小レンジで引く。 */
  var CUSTOM_HANDLE = 'custom-size-option';
  // 表示順（アルミ→木製、加工の重い順はデータ順に委ねる）。未知 option1 は末尾に出現順で温存。
  var CUSTOM_TYPE_ORDER = [
    'アルミ額入れ', 'アルミオーバーマットのみ', 'アルミブックマット', 'アルミスチレンパネル裏貼り', 'アルミオーバーマットパネル貼り',
    '木製額入れ', '木製オーバーマットのみ', '木製ブックマット', '木製スチレンパネル裏貼り', '木製オーバーマットスチレンパネル裏貼り', '木製パネル'
  ];
  // 規格(定形)サイズ商品だが、定形外は「ご希望寸法が収まる最小規格サイズ」で見積る handle（用紙と同じ方式）。
  // キャプションパネル/キャンバス木枠張りは定形のみ（ここに入れない）。
  var CUSTOM_ENCLOSING_HANDLES = ['bookmat-mount'];

  // "〜100mm" / "100mm" / "100" -> 100
  function bucketNum(s) {
    var m = String(s == null ? '' : s).match(/(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }
  // "A4(210×297)" / "200×200" -> {short, long} (mm)。取れなければ null
  function parseDims(label) {
    var m = normSize(String(label == null ? '' : label)).match(/(\d+)\s*×\s*(\d+)/);
    if (!m) return null;
    var a = parseInt(m[1], 10), b = parseInt(m[2], 10);
    if (!a || !b) return null;
    return { short: Math.min(a, b), long: Math.max(a, b) };
  }

  // raw[] -> { type: { shortMax(num): { longMax(num): { c: cents, id } } } }
  function shapeCustomFraming(raw) {
    var out = {};
    if (!Array.isArray(raw)) return out;
    raw.forEach(function (v) {
      try {
        if (v.product_handle !== CUSTOM_HANDLE) return;
        var t = v.option1;
        var sN = bucketNum(v.option2), lN = bucketNum(v.option3);
        if (!t || sN == null || lN == null) return;
        var price = Number(v.price);
        var cents = isFinite(price) ? price * 100 : NaN;
        out[t] = out[t] || {};
        out[t][sN] = out[t][sN] || {};
        out[t][sN][lN] = { c: cents, id: v.id };
      } catch (e) {
        console.error('[PLV2] bad custom-size row', v, e);
      }
    });
    return out;
  }

  // 種別を表示順に。未知は末尾へ出現順で温存
  function customTypeList(customFraming) {
    var keys = Object.keys(customFraming);
    return keys.slice().sort(function (a, b) {
      var ia = CUSTOM_TYPE_ORDER.indexOf(a), ib = CUSTOM_TYPE_ORDER.indexOf(b);
      if (ia === -1) ia = 9999 + keys.indexOf(a);
      if (ib === -1) ib = 9999 + keys.indexOf(b);
      return ia - ib;
    });
  }
  // 数値レンジキー配列から value を収める最小レンジ（昇順で最初に value<=key）。無ければ null
  function smallestFit(numKeys, value) {
    var sorted = numKeys.slice().sort(function (a, b) { return a - b; });
    for (var i = 0; i < sorted.length; i++) { if (value <= sorted[i]) return sorted[i]; }
    return null;
  }
  // type と短辺・長辺(mm) から定形外価格セル {c,id,sB,lB} を引く。範囲外/未設定は null
  function customPriceCell(customFraming, type, shortMm, longMm) {
    var byShort = customFraming[type];
    if (!byShort) return null;
    var sB = smallestFit(Object.keys(byShort).map(Number), shortMm);
    if (sB == null) return null;
    var byLong = byShort[sB];
    var lB = smallestFit(Object.keys(byLong).map(Number), longMm);
    if (lB == null) return null;
    var cell = byLong[lB];
    return { c: cell.c, id: cell.id, sB: sB, lB: lB };
  }

  // size名配列(["A4(210×297)",...]) と短辺長辺(mm) を内包する最小規格サイズ名（面積最小）。無ければ null。
  function enclosingSizeName(names, shortMm, longMm) {
    var best = null, bestArea = Infinity;
    (names || []).forEach(function (name) {
      var d = parseDims(name);
      if (!d) return;
      if (shortMm <= d.short && longMm <= d.long) {
        var area = d.short * d.long;
        if (area < bestArea) { bestArea = area; best = name; }
      }
    });
    return best;
  }
  // 用紙には真の定形外価格が無いため、定形外注文は内包する規格サイズで見積る。
  function enclosingPaperSize(pp, shortMm, longMm) {
    if (!pp || !pp.sizes) return null;
    return enclosingSizeName(Object.keys(pp.sizes), shortMm, longMm);
  }
  // 規格サイズ handle（option2/3 なし）の size -> {c,id} マップを取り出す
  function enclosingSizeMap(framing, handle) {
    return (framing[handle] && framing[handle][NO_OPT] && framing[handle][NO_OPT][NO_OPT]) || {};
  }
  // 定形外セクションに出す項目: matrix(custom-size-option 種別) + enclosing(収まるサイズ商品)。
  function customSectionItems(customFraming, framing) {
    var items = [];
    customTypeList(customFraming).forEach(function (t) { items.push({ kind: 'matrix', key: t, label: t }); });
    CUSTOM_ENCLOSING_HANDLES.forEach(function (h) {
      if (framing[h]) items.push({ kind: 'enclosing', key: h, label: FRAMING_LABELS[h] || h });
    });
    return items;
  }

  function buildAll(paper, framing, customFraming) {
    buildSectionA(paper);
    buildSectionB(framing, customFraming || {});
    buildSectionC(paper, framing, customFraming || {});
  }

  // ---- size highlight helpers ----
  // attach a listener so this table re-highlights when a size arrives; replay any pending size now.
  function registerSizeListener(highlightFn) {
    SIZE_LISTENERS.push(highlightFn);
    if (pendingHighlightSize) {
      try { highlightFn(pendingHighlightSize); } catch (e) { console.error('[PLV2] replay highlight error', e); }
    }
  }
  // mark rows whose data-size matches; clear others
  function applyRowHighlight(tbody, size) {
    if (!tbody) return;
    Array.prototype.forEach.call(tbody.querySelectorAll('tr'), function (tr) {
      if (size && tr.getAttribute('data-size') === size) tr.classList.add('plv2-row-highlight');
      else tr.classList.remove('plv2-row-highlight');
    });
  }

  /* ============ Section A: paper printing prices (category chips, columns = papers) ============ */
  function buildSectionA(paper) {
    var root = document.getElementById('plv2-section-a');
    if (!root) { console.error('[PLV2] #plv2-section-a missing'); return; }
    wirePriceClicks(root, 'paper');

    var cats = [];
    paper.forEach(function (p) { if (cats.indexOf(p.category) === -1) cats.push(p.category); });
    if (!cats.length) { root.appendChild(el('p', 'plv2-empty', '用紙データを読み込めませんでした。')); return; }

    // default: first real category (keeps initial column count low; no "すべて" default)
    var state = { cat: cats[0] };

    var filterBar = el('div', 'plv2-filterbar');
    var catRow = el('div', 'plv2-cat-row');
    // optional "すべて" chip first (selectable but not default)
    var allBtn = el('button', 'plv2-chip', 'すべて');
    allBtn.dataset.cat = '__all__';
    catRow.appendChild(allBtn);
    cats.forEach(function (c) {
      var b = el('button', 'plv2-chip', c);
      b.dataset.cat = c;
      if (c === state.cat) b.classList.add('plv2-chip-active');
      catRow.appendChild(b);
    });
    filterBar.appendChild(catRow);
    root.appendChild(filterBar);

    var tableWrap = el('div', 'plv2-table-wrap');
    root.appendChild(tableWrap);

    function visiblePapers() {
      return paper.filter(function (p) {
        return state.cat === '__all__' || p.category === state.cat;
      });
    }

    function renderTable() {
      tableWrap.innerHTML = '';
      var chosen = visiblePapers();
      if (!chosen.length) { tableWrap.appendChild(el('p', 'plv2-empty', '該当する用紙がありません。')); return; }

      var sizes = unionSizes(chosen);
      if (!sizes.length) { tableWrap.appendChild(el('p', 'plv2-empty', 'サイズデータがありません。')); return; }

      var scroller = el('div', 'plv2-scroll');
      var table = el('table', 'plv2-table');
      var thead = el('thead');
      var htr = el('tr');
      htr.appendChild(el('th', 'plv2-sticky-col', 'サイズ'));
      chosen.forEach(function (p) { htr.appendChild(el('th', null, p.title)); });
      thead.appendChild(htr);
      table.appendChild(thead);

      var tbody = el('tbody');
      sizes.forEach(function (s) {
        var tr = el('tr');
        tr.setAttribute('data-size', s);
        tr.appendChild(el('td', 'plv2-sticky-col', s));
        chosen.forEach(function (p) {
          var cell = p.sizes[s]; // {p:cents,id} | undefined
          if (cell && cell.p != null) {
            var href = p.url + '?variant=' + cell.id;
            tr.appendChild(priceCell(cell.p, href));
          } else {
            tr.appendChild(priceCell(null, null));
          }
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      scroller.appendChild(table);
      tableWrap.appendChild(scroller);

      // re-apply current recommended size after a (re)render
      applyRowHighlight(tbody, pendingHighlightSize);
    }

    catRow.addEventListener('click', function (e) {
      var btn = e.target.closest('.plv2-chip');
      if (!btn) return;
      state.cat = btn.dataset.cat;
      Array.prototype.forEach.call(catRow.children, function (c) { c.classList.remove('plv2-chip-active'); });
      btn.classList.add('plv2-chip-active');
      renderTable();
      trackPL('pricelist_paper_category', { category: state.cat });
    });

    // calc-tool sync: re-highlight on the live table
    registerSizeListener(function () {
      var tb = tableWrap.querySelector('tbody');
      applyRowHighlight(tb, pendingHighlightSize);
    });

    renderTable();
  }

  function unionSizes(papers) {
    var seen = {};
    var order = [];
    papers.forEach(function (p) {
      Object.keys(p.sizes).forEach(function (s) {
        if (!seen[s]) { seen[s] = true; order.push(s); }
      });
    });
    return sortSizes(order); // 論理サイズ順に整列
  }

  /* ============ Section B: framing / processing prices ============ */
  function buildSectionB(framing, customFraming) {
    var root = document.getElementById('plv2-section-b');
    if (!root) { console.error('[PLV2] #plv2-section-b missing'); return; }
    wirePriceClicks(root, 'framing');
    customFraming = customFraming || {};

    var handles = FRAMING_HANDLE_ORDER.filter(function (h) { return framing[h]; });
    var customItems = customSectionItems(customFraming, framing);
    if (!handles.length && !customItems.length) {
      root.appendChild(el('p', 'plv2-empty', '額装/加工データを読み込めませんでした。'));
      return;
    }

    // 定形/定形外 をトグルで切替（縦積みにしない）。両方ある時のみトグル表示。
    // ラベルは見出し右に置くコンパクト表記（詳細は section-desc が補足）。
    var hasStd = handles.length > 0, hasCustom = customItems.length > 0;
    var btnStd = el('button', 'plv2-toggle-btn', '定形');
    var btnCustom = el('button', 'plv2-toggle-btn', '定形外');
    btnStd.type = 'button'; btnCustom.type = 'button';
    if (hasStd && hasCustom) {
      var toggle = el('div', 'plv2-toggle');
      toggle.setAttribute('role', 'tablist');
      toggle.setAttribute('aria-label', 'サイズ種別の切替');
      toggle.appendChild(btnStd);
      toggle.appendChild(btnCustom);
      // 見出し行の右スロットに描画（無ければ従来どおりセクション先頭にフォールバック）
      var slot = document.getElementById('plv2-sec-b-toggle');
      if (slot) slot.appendChild(toggle);
      else root.appendChild(toggle);
    }
    var pane = el('div', 'plv2-pane');
    root.appendChild(pane);

    function show(which) {
      pane.innerHTML = '';
      var isStd = (which === 'std');
      btnStd.classList.toggle('plv2-toggle-active', isStd);
      btnCustom.classList.toggle('plv2-toggle-active', !isStd);
      btnStd.setAttribute('aria-selected', isStd ? 'true' : 'false');
      btnCustom.setAttribute('aria-selected', !isStd ? 'true' : 'false');
      if (!isStd && hasCustom) buildSectionBCustom(pane, customFraming, framing, customItems);
      else buildSectionBStandard(pane, framing, handles);
    }
    btnStd.addEventListener('click', function () { show('std'); trackPL('pricelist_size_type_toggle', { mode: 'std' }); });
    btnCustom.addEventListener('click', function () { show('custom'); trackPL('pricelist_size_type_toggle', { mode: 'custom' }); });
    show(hasStd ? 'std' : 'custom'); // 初期描画は計測しない（ユーザー操作のみ計上）
  }

  /* ---- Section B: 定形（規格）サイズの額装/加工価格 ---- */
  function buildSectionBStandard(root, framing, handles) {
    var ctrls = el('div', 'plv2-framing-ctrls');
    var typeSel = makeSelect('額装/加工');
    var procSel = makeSelect('仕様');
    ctrls.appendChild(typeSel.group);
    ctrls.appendChild(procSel.group);
    root.appendChild(ctrls);

    var tableWrap = el('div', 'plv2-table-wrap');
    root.appendChild(tableWrap);

    handles.forEach(function (h) {
      typeSel.sel.appendChild(new Option(FRAMING_LABELS[h] || h, h));
    });

    function refreshProc() {
      var h = typeSel.sel.value;
      var procs = Object.keys(framing[h] || {});
      fill(procSel.sel, procs.map(function (p) {
        return [p === NO_OPT ? '(加工なし)' : p, p];
      }));
      procSel.group.style.display = (procs.length === 1 && procs[0] === NO_OPT) ? 'none' : '';
      render();
    }
    function render() {
      tableWrap.innerHTML = '';
      var h = typeSel.sel.value, p = procSel.sel.value;
      // カラー(option3=額の色)は価格に影響しないため価格表では選ばせない。
      // 同一(仕様,サイズ)の価格は全色で同額なので任意の1色を代表として表示する。
      var byColor = (framing[h] && framing[h][p]) || null;
      var colorKey = byColor ? Object.keys(byColor)[0] : null;
      var sizeMap = (colorKey != null) ? byColor[colorKey] : null;
      if (!sizeMap) { tableWrap.appendChild(el('p', 'plv2-empty', '価格データがありません。')); return; }
      var sizes = sortSizes(Object.keys(sizeMap));
      var scroller = el('div', 'plv2-scroll');
      var table = el('table', 'plv2-table');
      var thead = el('thead'); var htr = el('tr');
      htr.appendChild(el('th', 'plv2-sticky-col', 'サイズ'));
      htr.appendChild(el('th', null, FRAMING_LABELS[h] || h));
      thead.appendChild(htr); table.appendChild(thead);
      var tbody = el('tbody');
      sizes.forEach(function (s) {
        var cell = sizeMap[s]; // {c:cents,id}
        var tr = el('tr');
        tr.setAttribute('data-size', s);
        tr.appendChild(el('td', 'plv2-sticky-col', s));
        if (cell && cell.c != null) {
          tr.appendChild(priceCell(cell.c, '/products/' + h + '?variant=' + cell.id));
        } else {
          tr.appendChild(priceCell(null, null));
        }
        tbody.appendChild(tr);
      });
      table.appendChild(tbody); scroller.appendChild(table);
      tableWrap.appendChild(scroller);
      applyRowHighlight(tbody, pendingHighlightSize);
    }

    typeSel.sel.addEventListener('change', function () { refreshProc(); trackPL('pricelist_framing_select', { mode: 'std', type: typeSel.sel.value }); });
    procSel.sel.addEventListener('change', render);

    // 計算ツール連動なし: 定形外サイズ計算は「用紙」専用のため、額装/加工テーブルには連動させない
    refreshProc();
  }

  /* ---- Section B: 定形外（カスタム）サイズの額装/加工価格 ----
   * matrix 種別=短辺×長辺マトリクス。enclosing 種別（ブックマット加工等）=規格サイズ表で、
   * ご希望寸法が収まる最小規格サイズの価格を適用（用紙と同じ方式）。 */
  function buildSectionBCustom(root, customFraming, framing, items) {
    var byKey = {};
    items.forEach(function (it) { byKey[it.key] = it; });

    var block = el('div', 'plv2-custom-block');
    var desc = el('p', 'plv2-section-desc', '');
    block.appendChild(desc);

    var ctrls = el('div', 'plv2-framing-ctrls');
    var typeSel = makeSelect('額装/加工（定形外）');
    ctrls.appendChild(typeSel.group);
    block.appendChild(ctrls);

    var tableWrap = el('div', 'plv2-table-wrap');
    block.appendChild(tableWrap);

    var note = el('p', 'plv2-note', '');
    block.appendChild(note);
    root.appendChild(block);

    items.forEach(function (it) { typeSel.sel.appendChild(new Option(it.label, it.key)); });

    function renderMatrix(key) {
      var byShort = customFraming[key] || null;
      if (!byShort) { tableWrap.appendChild(el('p', 'plv2-empty', '価格データがありません。')); return; }
      var shorts = Object.keys(byShort).map(Number).sort(function (a, b) { return a - b; });
      var longSet = {};
      shorts.forEach(function (s) { Object.keys(byShort[s]).forEach(function (l) { longSet[Number(l)] = true; }); });
      var longs = Object.keys(longSet).map(Number).sort(function (a, b) { return a - b; });

      var scroller = el('div', 'plv2-scroll');
      var table = el('table', 'plv2-table');
      var thead = el('thead'); var htr = el('tr');
      htr.appendChild(el('th', 'plv2-sticky-col', '短辺＼長辺'));
      longs.forEach(function (l) { htr.appendChild(el('th', null, '〜' + l + 'mm')); });
      thead.appendChild(htr); table.appendChild(thead);

      var tbody = el('tbody');
      shorts.forEach(function (s) {
        var tr = el('tr');
        tr.appendChild(el('td', 'plv2-sticky-col', '〜' + s + 'mm'));
        longs.forEach(function (l) {
          var cell = byShort[s] && byShort[s][l]; // {c,id}|undefined
          if (cell && cell.c != null) {
            tr.appendChild(priceCell(cell.c, '/products/' + CUSTOM_HANDLE + '?variant=' + cell.id));
          } else {
            tr.appendChild(priceCell(null, null));
          }
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody); scroller.appendChild(table);
      tableWrap.appendChild(scroller);
    }

    // enclosing 種別: 規格サイズ表（ご希望寸法は収まる最小サイズの価格）
    function renderEnclosing(handle) {
      var smap = enclosingSizeMap(framing, handle);
      var sizes = sortSizes(Object.keys(smap));
      if (!sizes.length) { tableWrap.appendChild(el('p', 'plv2-empty', '価格データがありません。')); return; }
      var scroller = el('div', 'plv2-scroll');
      var table = el('table', 'plv2-table');
      var thead = el('thead'); var htr = el('tr');
      htr.appendChild(el('th', 'plv2-sticky-col', 'サイズ（この寸法まで）'));
      htr.appendChild(el('th', null, FRAMING_LABELS[handle] || handle));
      thead.appendChild(htr); table.appendChild(thead);
      var tbody = el('tbody');
      sizes.forEach(function (s) {
        var cell = smap[s];
        var tr = el('tr');
        tr.appendChild(el('td', 'plv2-sticky-col', s));
        if (cell && cell.c != null) {
          tr.appendChild(priceCell(cell.c, '/products/' + handle + '?variant=' + cell.id));
        } else {
          tr.appendChild(priceCell(null, null));
        }
        tbody.appendChild(tr);
      });
      table.appendChild(tbody); scroller.appendChild(table);
      tableWrap.appendChild(scroller);
    }

    function render() {
      tableWrap.innerHTML = '';
      var it = byKey[typeSel.sel.value];
      if (!it) { tableWrap.appendChild(el('p', 'plv2-empty', '価格データがありません。')); return; }
      if (it.kind === 'enclosing') {
        desc.textContent = '規格サイズ以外（オーダーメイド）の価格です。ご希望寸法が「収まる最小の規格サイズ」の価格が適用されます。価格をクリックすると商品ページへ移動します。';
        note.textContent = '※ 価格は税込み表示です。例: 250×400mm のご希望は、収まる最小サイズの価格になります。';
        renderEnclosing(it.key);
      } else {
        desc.textContent = '規格サイズ以外（オーダーメイド）の額装/加工の価格です。短辺・長辺それぞれが「収まるレンジ（上限）」の価格になります。価格をクリックすると商品ページへ移動します。';
        note.textContent = '※ 価格は税込み表示です。表頭＝長辺の上限／表側＝短辺の上限。「-」は設定のない組合せです。';
        renderMatrix(it.key);
      }
    }

    typeSel.sel.addEventListener('change', function () { render(); trackPL('pricelist_framing_select', { mode: 'custom', type: typeSel.sel.value }); });
    render();
  }

  /* ============ Section C: 金額を比較する（最大3仕様を縦積みで選び金額比較＋見積） ============ */
  function buildSectionC(paper, framing, customFraming) {
    var root = document.getElementById('plv2-section-c');
    if (!root) { console.error('[PLV2] #plv2-section-c missing'); return; }
    customFraming = customFraming || {};
    var customItems = customSectionItems(customFraming, framing); // matrix + enclosing(ブックマット等)
    var customItemByKey = {};
    customItems.forEach(function (it) { customItemByKey[it.key] = it; });

    var handles = FRAMING_HANDLE_ORDER.filter(function (h) { return framing[h]; });
    if (!paper.length) {
      root.appendChild(el('p', 'plv2-empty', '比較に必要なデータが不足しています。'));
      return;
    }

    var NONE_FRAMING = '__noframe__';
    // オーバーマット / ブックマット のときだけ「額装サイズ」を別途選ぶ（マットで外寸が刷り寸と変わるため）
    function isMatSpec(o2) { return /オーバーマット|ブックマット/.test(o2 || ''); }

    // 表示数: 既定2 / PC最大3 / モバイル最大2（いずれも横並び）
    var MAX_PC = 3, MAX_MOBILE = 2, DEFAULT_COUNT = 2;
    var mqMobile = window.matchMedia('(max-width: 767px)');
    var visibleCount = DEFAULT_COUNT;

    var grid = el('div', 'plv2-cfg-grid');
    root.appendChild(grid);

    var cards = [];
    // 既定: 額装なし（用紙のみ）で開始。用紙だけは列ごとに変えて「用紙比較」が即成立するように
    var defaults = [NONE_FRAMING, NONE_FRAMING, NONE_FRAMING];
    for (var i = 0; i < 3; i++) {
      // 3枚目(index 2)だけ「×」で削除可能（既定は非表示）
      var onRemove = (i === 2) ? function () { visibleCount = DEFAULT_COUNT; layout(); } : null;
      var defPaper = (paper[i] || paper[0] || {}).handle || null;
      var card = makeConfigCard(i + 1, defaults[i], onRemove, defPaper);
      cards.push(card);
      grid.appendChild(card.root);
    }

    // 「仕様を追加」ボタン（PC のみ 3 枚目まで・モバイルは 2 枚で打ち止め）
    var addWrap = el('div', 'plv2-cfg-addwrap');
    var addBtn = el('button', 'plv2-cfg-add', '＋ 仕様を追加して比較');
    addWrap.appendChild(addBtn);
    root.appendChild(addWrap);
    addBtn.addEventListener('click', function () {
      var cap = mqMobile.matches ? MAX_MOBILE : MAX_PC;
      if (visibleCount < cap) { visibleCount++; layout(); trackPL('pricelist_compare_add', { visible: visibleCount }); }
    });

    // ---- 下部: 選択した仕様を「見積書(PDF)」で発行（注文は各カードの「この仕様で注文」から個別に）----
    var quoteWrap = el('div', 'plv2-quote-wrap');
    var quoteBtn = el('button', 'plv2-quote-btn', '選択した仕様で見積書を作成');
    quoteWrap.appendChild(quoteBtn);
    root.appendChild(quoteWrap);

    quoteBtn.addEventListener('click', function () {
      if (typeof window.openQuoteModal !== 'function') {
        console.error('[PLV2] openQuoteModal not found');
        alert('見積機能を読み込めませんでした。ページを再読み込みしてお試しください。');
        return;
      }
      var items = [];
      cards.forEach(function (cd) { if (cd.isVisible()) items = items.concat(cd.getQuoteItems()); });
      if (!items.length) {
        alert('「見積に含める」にチェックした仕様がありません。価格が表示されている仕様を選んでチェックしてください。');
        return;
      }
      var subtotal = items.reduce(function (s, it) { return s + it.line_price; }, 0);
      window.openQuoteModal({ items: items, items_subtotal_price: subtotal, total_weight: 0 });
      trackPL('pricelist_quote_create', { item_count: items.length, subtotal: Math.round(subtotal / 100) });
    });

    // 注文は各カードの「この仕様で注文」リンクから（商品ページをサイズ選択済みで開く）。
    // カート一括投入をやめた理由: 注文時にデータ入稿・色・額装仕上げ等のオプション指定が
    // 商品ページ側で必要なため、ユーザーに商品ページで仕様を確定してもらう（Owner 指示 2026-06-16）。

    // 計算ツール連動なし: 定形外サイズ計算は「用紙印刷の価格」表専用（比較ビルダーは手動選択）

    // レイアウト: 表示枚数・列数・追加ボタン表示をビューポートに合わせて更新
    function layout() {
      var mobile = mqMobile.matches;
      var cap = mobile ? MAX_MOBILE : MAX_PC;
      if (visibleCount > cap) visibleCount = cap;
      if (visibleCount < DEFAULT_COUNT) visibleCount = DEFAULT_COUNT;
      cards.forEach(function (cd, idx) { cd.setVisible(idx < visibleCount); });
      grid.style.gridTemplateColumns = 'repeat(' + (mobile ? MAX_MOBILE : visibleCount) + ', 1fr)';
      addBtn.style.display = (visibleCount < cap) ? '' : 'none';
    }
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', layout);
    else if (mqMobile.addListener) mqMobile.addListener(layout); // 旧 Safari
    layout();

    /* ---- 1枚の仕様カード（規格/定形外 を切替）。規格: 用紙→用紙サイズ→額装/加工→仕様→カラー→額装サイズ。
           定形外: 用紙→W×H入力→額装/加工(定形外種別)。数量は共通。 ---- */
    function makeConfigCard(index, defaultHandle, onRemove, defaultPaperHandle) {
      var cardEl = el('div', 'plv2-cfg-card');
      var _visible = true;
      var mode = 'std'; // 'std' | 'custom'

      var head = el('div', 'plv2-cfg-head');
      head.appendChild(el('span', 'plv2-cfg-title', '仕様 ' + index));
      var headRight = el('div', 'plv2-cfg-headright');
      var incLabel = el('label', 'plv2-cfg-include');
      var incCb = document.createElement('input');
      incCb.type = 'checkbox';
      incCb.checked = true; // 既定で全てON（見積書PDFに含める。注文は各カードの「この仕様で注文」から）
      incLabel.appendChild(incCb);
      incLabel.appendChild(el('span', null, '見積に含める'));
      headRight.appendChild(incLabel);
      if (onRemove) {
        var rmBtn = el('button', 'plv2-cfg-remove', '×');
        rmBtn.setAttribute('aria-label', 'この仕様を削除');
        rmBtn.setAttribute('type', 'button');
        rmBtn.addEventListener('click', onRemove);
        headRight.appendChild(rmBtn);
      }
      head.appendChild(headRight);
      cardEl.appendChild(head);

      var body = el('div', 'plv2-cfg-body');
      cardEl.appendChild(body);

      var paperSel = makeSelect('用紙');
      var sizeModeSel = makeSelect('サイズ種別');
      var paperSizeSel = makeSelect('用紙サイズ');
      var typeSel = makeSelect('額装/加工');
      var specSel = makeSelect('仕様');
      var colorSel = makeSelect('カラー');
      var frameSizeSel = makeSelect('額装サイズ');

      // 定形外サイズ入力（横×縦 mm）
      var customGroup = el('div', 'plv2-select-group');
      customGroup.appendChild(el('label', null, '定形外サイズ (mm)'));
      var dimRow = el('div', 'plv2-dim-row');
      var wIn = document.createElement('input');
      wIn.type = 'number'; wIn.min = '1'; wIn.step = '1'; wIn.placeholder = '横';
      wIn.className = 'plv2-qty-input plv2-dim-input';
      var hIn = document.createElement('input');
      hIn.type = 'number'; hIn.min = '1'; hIn.step = '1'; hIn.placeholder = '縦';
      hIn.className = 'plv2-qty-input plv2-dim-input';
      dimRow.appendChild(wIn);
      dimRow.appendChild(el('span', 'plv2-dim-x', '×'));
      dimRow.appendChild(hIn);
      customGroup.appendChild(dimRow);

      body.appendChild(paperSel.group);
      body.appendChild(sizeModeSel.group);
      body.appendChild(paperSizeSel.group);
      body.appendChild(customGroup);
      body.appendChild(typeSel.group);
      body.appendChild(specSel.group);
      body.appendChild(colorSel.group);
      body.appendChild(frameSizeSel.group);

      // 数量
      var qtyGroup = el('div', 'plv2-qty-group');
      var qtyLab = el('label', null, '数量');
      var qtyInput = document.createElement('input');
      qtyInput.type = 'number'; qtyInput.min = '1'; qtyInput.step = '1'; qtyInput.value = '1';
      qtyInput.className = 'plv2-qty-input';
      var qid = 'plv2-qty-' + Math.random().toString(36).slice(2, 8);
      qtyInput.id = qid; qtyLab.htmlFor = qid;
      qtyGroup.appendChild(qtyLab); qtyGroup.appendChild(qtyInput);
      body.appendChild(qtyGroup);

      // 価格表示
      var prices = el('div', 'plv2-cfg-prices');
      var lnPrint = priceLine('印刷');
      var lnFrame = priceLine('額装');
      var lnTotal = priceLine('合計（単価）'); lnTotal.row.className = 'plv2-cfg-line plv2-cfg-total';
      var lnSub = priceLine('小計'); lnSub.row.className = 'plv2-cfg-line plv2-cfg-sub';
      var warn = el('div', 'plv2-cfg-warn'); warn.style.display = 'none';
      prices.appendChild(lnPrint.row);
      prices.appendChild(lnFrame.row);
      prices.appendChild(lnTotal.row);
      prices.appendChild(lnSub.row);
      prices.appendChild(warn);
      cardEl.appendChild(prices);

      // この仕様で注文: 商品ページをサイズ選択済み(?variant)で開く。用紙＝内包/規格 variant、
      // 額装＝matrix(custom-size-option)/enclosing(自handle) variant で見積額と一致。額装は別商品＝別タブ。
      var orderRow = el('div', 'plv2-cfg-order');
      var orderLink = el('button', 'plv2-cfg-order-btn', 'この仕様で注文 →');
      orderLink.type = 'button';
      orderRow.appendChild(orderLink);
      cardEl.appendChild(orderRow);
      orderLink.addEventListener('click', function () {
        var st = compute();
        var urls = [];
        if (st.pc != null && st.pId != null) {
          var pbase = (st.pp && st.pp.url) ? st.pp.url : (st.pp ? '/products/' + st.pp.handle : null);
          if (pbase) urls.push(pbase + '?variant=' + st.pId);
        }
        if (!st.noFraming && st.fc != null && st.fId != null) {
          var fHandle;
          if (st.mode === 'std') fHandle = st.h;
          else { var fit = customItemByKey[st.h]; fHandle = (fit && fit.kind === 'enclosing') ? st.h : CUSTOM_HANDLE; }
          if (fHandle) urls.push('/products/' + fHandle + '?variant=' + st.fId);
        }
        if (!urls.length) { alert('価格が表示されている仕様を選んでから「この仕様で注文」を押してください。'); return; }
        trackPL('pricelist_order_start', { mode: st.mode, has_framing: urls.length > 1, targets: urls.length, handle: (st.pp && st.pp.handle) || '' });
        // 比較ページを残すため新規タブで開く（用紙→額装の順）
        urls.forEach(function (u) { window.open(u, '_blank'); });
      });

      // 選択肢を流し込む
      paper.forEach(function (p) { paperSel.sel.appendChild(new Option(p.title, p.handle)); });
      if (defaultPaperHandle) {
        var hasPaper = Array.prototype.some.call(paperSel.sel.options, function (o) { return o.value === defaultPaperHandle; });
        if (hasPaper) paperSel.sel.value = defaultPaperHandle;
      }
      sizeModeSel.sel.appendChild(new Option('定形サイズ', 'std'));
      if (customItems.length) sizeModeSel.sel.appendChild(new Option('定形外サイズ', 'custom'));
      else sizeModeSel.group.style.display = 'none'; // 定形外データが無ければ切替自体を隠す

      function paperByHandle(h) {
        for (var i = 0; i < paper.length; i++) if (paper[i].handle === h) return paper[i];
        return null;
      }

      // typeSel を mode に応じて再構築（「額装なし」は共通。直前選択は同一値があれば温存）
      function rebuildTypeOptions() {
        var prev = typeSel.sel.value;
        typeSel.sel.innerHTML = '';
        typeSel.sel.appendChild(new Option('額装なし（用紙のみ）', NONE_FRAMING));
        if (mode === 'std') {
          handles.forEach(function (h) { typeSel.sel.appendChild(new Option(FRAMING_LABELS[h] || h, h)); });
        } else {
          customItems.forEach(function (it) { typeSel.sel.appendChild(new Option(it.label, it.key)); });
        }
        var keep = Array.prototype.some.call(typeSel.sel.options, function (o) { return o.value === prev; });
        typeSel.sel.value = keep ? prev : (mode === 'std' ? defaultHandle : NONE_FRAMING);
      }

      function refreshPaperSizes(preferred) {
        var pp = paperByHandle(paperSel.sel.value);
        var sizes = pp ? sortSizes(Object.keys(pp.sizes)) : [];
        fill(paperSizeSel.sel, sizes.map(function (s) { return [s, s]; }));
        if (preferred && sizes.indexOf(preferred) !== -1) paperSizeSel.sel.value = preferred;
      }

      // ---- 規格モードの 仕様→カラー→額装サイズ 連鎖 ----
      function refreshSpec() {
        var h = typeSel.sel.value;
        if (h === NONE_FRAMING) {
          specSel.group.style.display = 'none';
          colorSel.group.style.display = 'none';
          frameSizeSel.group.style.display = 'none';
          recompute();
          return;
        }
        var procs = Object.keys(framing[h] || {});
        fill(specSel.sel, procs.map(function (p) { return [p === NO_OPT ? '(指定なし)' : p, p]; }));
        specSel.group.style.display = (procs.length === 1 && procs[0] === NO_OPT) ? 'none' : '';
        refreshColor();
      }
      function refreshColor() {
        var h = typeSel.sel.value, p = specSel.sel.value;
        var colors = Object.keys((framing[h] && framing[h][p]) || {});
        fill(colorSel.sel, colors.map(function (c) { return [c === NO_OPT ? '(指定なし)' : c, c]; }));
        colorSel.group.style.display = (colors.length === 1 && colors[0] === NO_OPT) ? 'none' : '';
        refreshFrameSize();
      }
      var matFrameTooSmall = false; // ST-22②: 用紙>額装でどの額装にも収まらない状態フラグ
      function refreshFrameSize() {
        var h = typeSel.sel.value, p = specSel.sel.value, c = colorSel.sel.value;
        if (h === NONE_FRAMING || !isMatSpec(p)) {
          frameSizeSel.group.style.display = 'none'; // 通常は額装サイズ=用紙サイズ（別途選択不要）
          matFrameTooSmall = false;
          recompute();
          return;
        }
        var fmap = (framing[h] && framing[h][p] && framing[h][p][c]) || {};
        var allSizes = sortSizes(Object.keys(fmap));
        // ST-22②: オーバーマット/ブックマット等は用紙が額装の内側に収まる必要があるため、
        //  額装サイズの選択肢を「選択中の用紙サイズを内包する(=短辺・長辺とも以上の)もの」だけに制限する。
        //  これで 用紙>額装 の不正な組合せをそもそも選べなくし、見積りも算出しない。
        var pd = parseDims(paperSizeSel.sel.value || '');
        var sizes = allSizes;
        if (pd) {
          sizes = allSizes.filter(function (s) {
            var d = parseDims(s);
            return d && pd.short <= d.short && pd.long <= d.long;
          });
        }
        matFrameTooSmall = (allSizes.length > 0 && sizes.length === 0);
        if (matFrameTooSmall) {
          // 用紙が大きすぎてどの額装にも収まらない → 見積りを出さず、recompute で案内を表示。
          fill(frameSizeSel.sel, []);
          frameSizeSel.group.style.display = 'none';
          recompute();
          return;
        }
        var preferred = frameSizeSel.sel.value || paperSizeSel.sel.value;
        fill(frameSizeSel.sel, sizes.map(function (s) { return [s, s]; }));
        if (preferred && sizes.indexOf(preferred) !== -1) frameSizeSel.sel.value = preferred;
        frameSizeSel.group.style.display = sizes.length ? '' : 'none';
        recompute();
      }

      // ---- モード切替（表示要素の出し分け + typeSel 再構築） ----
      function applyMode() {
        mode = (sizeModeSel.sel.value === 'custom') ? 'custom' : 'std';
        var isCustom = (mode === 'custom');
        paperSizeSel.group.style.display = isCustom ? 'none' : '';
        customGroup.style.display = isCustom ? '' : 'none';
        rebuildTypeOptions();
        if (isCustom) {
          // 定形外は種別が仕様を内包するため 仕様/カラー/額装サイズ は使わない
          specSel.group.style.display = 'none';
          colorSel.group.style.display = 'none';
          frameSizeSel.group.style.display = 'none';
          recompute();
        } else {
          refreshSpec(); // 末尾で recompute
        }
      }

      function customDims() {
        var w = parseInt(wIn.value, 10), h = parseInt(hIn.value, 10);
        if (!w || !h || w <= 0 || h <= 0) return null;
        return { short: Math.min(w, h), long: Math.max(w, h), w: w, h: h };
      }

      // 現在の構成 → 価格(cents)を算出（mode で分岐）
      function compute() {
        var pp = paperByHandle(paperSel.sel.value);
        var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        var h = typeSel.sel.value;
        var noFraming = (h === NONE_FRAMING);

        if (mode === 'custom') {
          var dims = customDims();
          var encSize = dims ? enclosingPaperSize(pp, dims.short, dims.long) : null;
          var pCellC = (pp && encSize) ? pp.sizes[encSize] : null;
          var pcC = pCellC ? pCellC.p : null;
          var pIdC = pCellC ? pCellC.id : null; // 用紙=内包規格サイズの variant
          var fcC = null, fIdC = null, fInfo = null;
          if (!noFraming && dims) {
            var it = customItemByKey[h];
            if (it && it.kind === 'matrix') {
              var fcell = customPriceCell(customFraming, h, dims.short, dims.long);
              if (fcell) { fcC = fcell.c; fIdC = fcell.id; fInfo = { kind: 'matrix', sB: fcell.sB, lB: fcell.lB }; }
            } else if (it && it.kind === 'enclosing') {
              // ブックマット等: 収まる最小規格サイズの価格（用紙と同じ方式）
              var smap = enclosingSizeMap(framing, h);
              var encName = enclosingSizeName(Object.keys(smap), dims.short, dims.long);
              var ecell = encName ? smap[encName] : null;
              if (ecell) { fcC = ecell.c; fIdC = ecell.id; fInfo = { kind: 'enclosing', encName: encName }; }
            }
          }
          return { mode: 'custom', pp: pp, dims: dims, encSize: encSize, pc: pcC, pId: pIdC,
                   h: h, noFraming: noFraming, fc: fcC, fId: fIdC, fInfo: fInfo, qty: qty };
        }

        // std
        var psize = paperSizeSel.sel.value;
        var pCell = (pp && pp.sizes[psize]) || null;
        var pc = pCell ? pCell.p : null;
        var pId = pCell ? pCell.id : null;
        var o2 = specSel.sel.value, o3 = colorSel.sel.value;
        var fsize = isMatSpec(o2) ? frameSizeSel.sel.value : psize;
        var fc = null, fId = null;
        if (!noFraming) {
          var fmap = (framing[h] && framing[h][o2] && framing[h][o2][o3]) || {};
          var fCell = fmap[fsize] || null;
          fc = fCell ? fCell.c : null;
          fId = fCell ? fCell.id : null;
        }
        return { mode: 'std', pp: pp, psize: psize, pc: pc, pId: pId, h: h, noFraming: noFraming,
                 o2: o2, o3: o3, fsize: fsize, fc: fc, fId: fId, qty: qty };
      }

      function recompute() {
        var st = compute();
        lnPrint.val.textContent = st.pc != null ? yen(st.pc) : '-';
        lnFrame.val.textContent = st.noFraming ? '—' : (st.fc != null ? yen(st.fc) : '未対応');

        var unit = null;
        if (st.pc != null && (st.noFraming || st.fc != null)) unit = st.pc + (st.fc || 0);
        lnTotal.val.textContent = unit != null ? yen(unit) : '-';
        lnSub.label.textContent = '小計（×' + st.qty + '）';
        lnSub.val.textContent = unit != null ? yen(unit * st.qty) : '-';

        // 注意喚起
        var msg = '';
        if (matFrameTooSmall) {
          msg = '額装サイズより小さい用紙サイズをお選びください。';
        } else if (st.mode === 'custom') {
          if (!st.dims) msg = '横・縦のサイズ（mm）を入力してください。';
          else if (st.pc == null) msg = 'この用紙には入力サイズを収める規格がありません。サイズか用紙を見直してください。';
          else if (!st.noFraming && st.fc == null) msg = 'この額装/加工は入力サイズが対応範囲外です。サイズか種別を見直してください。';
        } else if (!st.noFraming && st.pc != null && st.fc == null) {
          msg = 'この額装サイズの価格設定がありません。サイズを変更してください。';
        }
        if (msg) { warn.textContent = msg; warn.style.display = ''; }
        else { warn.style.display = 'none'; }
        cardEl.classList.toggle('plv2-cfg-off', !incCb.checked);
      }

      function getQuoteItems() {
        if (!incCb.checked) return [];
        var st = compute();
        var items = [];
        if (st.mode === 'custom') {
          if (st.pc != null && st.pp) {
            items.push({
              product_title: st.pp.title,
              variant_title: st.encSize,
              properties: { 'ご希望サイズ': st.dims.w + '×' + st.dims.h + 'mm（定形外）' },
              price: st.pc, quantity: st.qty, line_price: st.pc * st.qty
            });
          }
          if (!st.noFraming && st.fc != null) {
            var fi = st.fInfo || {};
            var fvt = (fi.kind === 'matrix')
              ? ('短辺〜' + fi.sB + 'mm / 長辺〜' + fi.lB + 'mm')
              : (fi.encName || '');
            var fpt = (customItemByKey[st.h] && customItemByKey[st.h].label) || st.h;
            items.push({
              product_title: fpt,
              variant_title: fvt,
              properties: { 'ご希望サイズ': st.dims.w + '×' + st.dims.h + 'mm（定形外）' },
              price: st.fc, quantity: st.qty, line_price: st.fc * st.qty
            });
          }
          return items;
        }
        // std
        if (st.pc != null) {
          items.push({
            product_title: st.pp ? st.pp.title : '用紙',
            variant_title: st.psize,
            properties: {}, price: st.pc, quantity: st.qty, line_price: st.pc * st.qty
          });
        }
        if (!st.noFraming && st.fc != null) {
          var parts = [st.fsize];
          if (st.o2 && st.o2 !== NO_OPT) parts.push(st.o2);
          if (st.o3 && st.o3 !== NO_OPT) parts.push(st.o3);
          items.push({
            product_title: FRAMING_LABELS[st.h] || st.h,
            variant_title: parts.join(' / '),
            properties: {}, price: st.fc, quantity: st.qty, line_price: st.fc * st.qty
          });
        }
        return items;
      }

      // カート投入用ライン（{id:variantId, quantity, properties}）。入力した仕様をそのまま注文へ。
      // 定形外は希望寸法を line item プロパティで保持（用紙は内包規格 variant＋希望寸法注記）。
      function getCartLineItems() {
        if (!incCb.checked) return [];
        var st = compute();
        var lines = [];
        var customProp = (st.mode === 'custom' && st.dims)
          ? { 'ご希望サイズ': st.dims.w + '×' + st.dims.h + 'mm（定形外）' } : {};
        if (st.pc != null && st.pId != null) {
          lines.push({ id: st.pId, quantity: st.qty, properties: Object.assign({}, customProp) });
        }
        if (!st.noFraming && st.fc != null && st.fId != null) {
          lines.push({ id: st.fId, quantity: st.qty, properties: Object.assign({}, customProp) });
        }
        return lines;
      }

      // 計算ツール連動（規格モードのみ）: 推奨サイズを用紙サイズ(+表示中なら額装サイズ)に反映
      function applySize(size) {
        if (mode !== 'std') return;
        var pp = paperByHandle(paperSel.sel.value);
        if (pp && pp.sizes[size]) {
          paperSizeSel.sel.value = size;
          if (frameSizeSel.group.style.display !== 'none') {
            var has = Array.prototype.some.call(frameSizeSel.sel.options, function (o) { return o.value === size; });
            if (has) frameSizeSel.sel.value = size;
          }
          recompute();
        }
      }

      // events
      paperSel.sel.addEventListener('change', function () {
        refreshPaperSizes();
        if (mode === 'std') refreshFrameSize(); else recompute();
      });
      sizeModeSel.sel.addEventListener('change', function () { applyMode(); trackPL('pricelist_compare_mode', { mode: sizeModeSel.sel.value }); });
      paperSizeSel.sel.addEventListener('change', refreshFrameSize);
      typeSel.sel.addEventListener('change', function () {
        if (mode === 'std') refreshSpec(); else recompute();
      });
      specSel.sel.addEventListener('change', refreshColor);
      colorSel.sel.addEventListener('change', refreshFrameSize);
      frameSizeSel.sel.addEventListener('change', recompute);
      wIn.addEventListener('input', recompute);
      hIn.addEventListener('input', recompute);
      qtyInput.addEventListener('input', recompute);
      incCb.addEventListener('change', recompute);

      // init
      refreshPaperSizes();
      applyMode(); // 既定 std → refreshSpec → recompute

      return {
        root: cardEl,
        getQuoteItems: getQuoteItems,
        getCartLineItems: getCartLineItems,
        applySize: applySize,
        setVisible: function (v) { _visible = v; cardEl.style.display = v ? '' : 'none'; },
        isVisible: function () { return _visible; }
      };
    }

    function priceLine(labelText) {
      var row = el('div', 'plv2-cfg-line');
      var label = el('span', 'plv2-cfg-lab', labelText);
      var val = el('span', 'plv2-cfg-val', '-');
      row.appendChild(label); row.appendChild(val);
      return { row: row, label: label, val: val };
    }
  }

  /* ---- select helpers ---- */
  function makeSelect(labelText) {
    var group = el('div', 'plv2-select-group');
    var lab = el('label', null, labelText);
    var sel = document.createElement('select');
    var id = 'plv2-sel-' + Math.random().toString(36).slice(2, 8);
    sel.id = id; lab.htmlFor = id;
    group.appendChild(lab); group.appendChild(sel);
    return { group: group, sel: sel };
  }
  function fill(sel, pairs) {
    sel.innerHTML = '';
    pairs.forEach(function (pr) { sel.appendChild(new Option(pr[0], pr[1])); });
  }
})();
